import { Injectable } from "@angular/core";
import { CVApiService } from "../../services/cv-api.service";

@Injectable({
    providedIn: "root",
})
export class BroadcastDetailsService {
    constructor(private cvApiService: CVApiService) {}

    public async GetBroadcast(broadcastId) {
        try {
            const response = await this.cvApiService.get<any>(
                "/api/v1/broadcast/" + broadcastId
            );
            if (response.status_code >= 200 && response.status_code < 300)
                return response.data;
            else throw response;
        } catch (err) {
            console.error("Failed to get broadcast.");
            throw err;
        }
    }

    public async SetBroadcastAsRead(broadcastId) {
        try {
            const response = await this.cvApiService.put(
                "/api/v2/dashboards/modules/setBroadcastAsRead/" + broadcastId
            );
            if (response.status_code >= 200 && response.status_code < 300)
                return response.data;
            else throw response;
        } catch (err) {
            console.error("Failed to set broadcast as read.");
            throw err;
        }
    }

    public async ToggleWorkAidFavoriteStatus(broadcastId) {
        try {
            const response = await this.cvApiService.put(
                "/api/v2/dashboards/modules/toggleWorkAidFavoriteStatus/" +
                    broadcastId
            );
            if (response.status_code >= 200 && response.status_code < 300)
                return response.data;
            else throw response;
        } catch (err) {
            console.error("Failed to set broadcast as favorite.");
            throw err;
        }
    }

    public async GetBroadcastExtraData(broadcastId) {
        try {
            const response = await this.cvApiService.get<any>(
                "/api/v1/broadcast/"+ broadcastId +"/extra_data"
            );
            if (response.status_code >= 200 && response.status_code < 300)
                return response.data;
            else throw response;
        } catch (err) {
            console.error("Failed to get extra broadcast data.");
            throw err;
        }
    }
}

